import { ConditionalRendering, Skeleton } from "@marketplace/ui";
import { useSetAtom } from "jotai";
import { useResetAtom } from "jotai/utils";

import { orderDetailModalAtom } from "../../atoms/order-detail-atom";
import type { GetOrderListResponseDto } from "../../dtos/get-order-list-response-dto";
import { OrderItem } from "../order-item";

type OrderListProps = {
  orderListData: GetOrderListResponseDto["data"];
  isLoading: boolean;
};

const OrderListLoader = () => {
  const skeletonKeys = [
    "order-loader-1",
    "order-loader-2",
    "order-loader-3",
    "order-loader-4"
  ];
  return skeletonKeys.map((key) => <Skeleton key={key} height={208} />);
};

export const OrderList = ({ orderListData, isLoading }: OrderListProps) => {
  const setOrderDetailModal = useSetAtom(orderDetailModalAtom);
  const resetOrderDetailModal = useResetAtom(orderDetailModalAtom);

  const handleSeeDetailButtonOnChange = (orderId: string) => {
    resetOrderDetailModal();
    const orderData = orderListData.find((o) => o.id === orderId);
    setOrderDetailModal({ visible: true, data: orderData! });
  };

  return (
    <section className="my-6 space-y-6">
      <ConditionalRendering condition={isLoading}>
        <OrderListLoader />
      </ConditionalRendering>
      <ConditionalRendering condition={!isLoading && orderListData.length}>
        {orderListData.map((orderItem) => (
          <OrderItem
            key={orderItem.id}
            orderItem={orderItem}
            seeDetailButtonOnChange={() =>
              handleSeeDetailButtonOnChange(orderItem.id)
            }
          />
        ))}
      </ConditionalRendering>
    </section>
  );
};
